import { render, staticRenderFns } from "./SalarySplit.vue?vue&type=template&id=3dee8a92&scoped=true&"
import script from "./SalarySplit.vue?vue&type=script&lang=js&"
export * from "./SalarySplit.vue?vue&type=script&lang=js&"
import style0 from "./SalarySplit.vue?vue&type=style&index=0&id=3dee8a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dee8a92",
  null
  
)

export default component.exports